import React from 'react';
import PropTypes from 'prop-types';

import MaterialDatePicker from 'material-ui-pickers/DatePicker';

const DatePicker = ({
  input,
  label,
}) => (
  <MaterialDatePicker
    label={label}
    format="MM/DD/YYYY"
    value={input.value || null}
    onChange={date => input.onChange(date.format('YYYY-MM-DD'))}
  />
);

DatePicker.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
};

DatePicker.defaultProps = {
  input: {
    value: null,
    onChange: () => {},
  },
  label: '',
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/common/components/DatePicker/DatePicker.js